/**
 * 图标注册表 - 按需导入Ant Design图标
 * 真正的按需导入，只加载项目中实际使用的图标
 *
 * 优势:
 * 1. 减少bundle体积 - 不加载未使用的图标
 * 2. 加快构建速度
 * 3. 提高运行时性能
 *
 * 使用方式:
 * import { getIcon } from '@/utils/iconRegistry';
 * const IconComponent = getIcon('HomeOutlined');
 * if (IconComponent) {
 *   return <IconComponent />;
 * }
 */

// 按需导入实际使用的图标
import {
  AccountBookOutlined,
  AlertOutlined,
  ApartmentOutlined,
  ApiOutlined,
  AppstoreAddOutlined,
  AppstoreOutlined,
  AreaChartOutlined,
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BarcodeOutlined,
  BellOutlined,
  BgColorsOutlined,
  BlockOutlined,
  BookOutlined,
  BranchesOutlined,
  BugOutlined,
  BulbOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  CarOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  ClearOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  CloudOutlined,
  CloudUploadOutlined,
  CompressOutlined,
  ControlOutlined,
  CopyOutlined,
  CreditCardOutlined,
  CrownOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DeleteOutlined,
  DesktopOutlined,
  DollarOutlined,
  DownOutlined,
  DownloadOutlined,
  DragOutlined,
  EditOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
  EyeOutlined,
  FallOutlined,
  FieldTimeOutlined,
  FileExcelOutlined,
  FileOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FileZipOutlined,
  FilterOutlined,
  FireOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  FullscreenOutlined,
  FundOutlined,
  GiftOutlined,
  GlobalOutlined,
  HistoryOutlined,
  HomeOutlined,
  IdcardOutlined,
  ImportOutlined,
  InboxOutlined,
  InfoCircleOutlined,
  InteractionOutlined,
  KeyOutlined,
  LineChartOutlined,
  LinkOutlined,
  LoadingOutlined,
  LockOutlined,
  LoginOutlined,
  LogoutOutlined,
  MailOutlined,
  ManOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
  MinusCircleOutlined,
  MobileOutlined,
  MoneyCollectOutlined,
  MonitorOutlined,
  MoonOutlined,
  MoreOutlined,
  NodeIndexOutlined,
  OrderedListOutlined,
  PaperClipOutlined,
  PartitionOutlined,
  PauseCircleOutlined,
  PhoneOutlined,
  PicLeftOutlined,
  PictureOutlined,
  PieChartOutlined,
  PlayCircleOutlined,
  PlusOutlined,
  PoweroffOutlined,
  PrinterOutlined,
  ProfileOutlined,
  ProjectOutlined,
  QrcodeOutlined,
  QuestionCircleOutlined,
  QuestionOutlined,
  ReloadOutlined,
  RiseOutlined,
  RocketOutlined,
  RollbackOutlined,
  SafetyCertificateOutlined,
  SafetyOutlined,
  SaveOutlined,
  SearchOutlined,
  SendOutlined,
  SettingOutlined,
  ShareAltOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  SketchOutlined,
  SolutionOutlined,
  StarFilled,
  StarOutlined,
  StockOutlined,
  SunOutlined,
  SwapOutlined,
  SyncOutlined,
  TableOutlined,
  TagOutlined,
  TagsOutlined,
  TeamOutlined,
  TransactionOutlined,
  TranslationOutlined,
  TrophyOutlined,
  TruckOutlined,
  UnlockOutlined,
  UnorderedListOutlined,
  UpOutlined,
  UploadOutlined,
  UserOutlined,
  UserSwitchOutlined,
  VideoCameraOutlined,
  WalletOutlined,
  WarningOutlined,
  WomanOutlined,
} from '@ant-design/icons';

// 图标注册表映射
type IconRegistry = Record<string, React.ComponentType>;

export const iconRegistry: IconRegistry = {
  AccountBookOutlined,
  AlertOutlined,
  ApartmentOutlined,
  ApiOutlined,
  AppstoreAddOutlined,
  AppstoreOutlined,
  AreaChartOutlined,
  ArrowDownOutlined,
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ArrowUpOutlined,
  AuditOutlined,
  BankOutlined,
  BarChartOutlined,
  BarcodeOutlined,
  BellOutlined,
  BgColorsOutlined,
  BlockOutlined,
  BookOutlined,
  BranchesOutlined,
  BugOutlined,
  BulbOutlined,
  CalculatorOutlined,
  CalendarOutlined,
  CarOutlined,
  CheckCircleOutlined,
  CheckOutlined,
  ClearOutlined,
  ClockCircleOutlined,
  CloseCircleOutlined,
  CloseOutlined,
  CloudOutlined,
  CloudUploadOutlined,
  CompressOutlined,
  ControlOutlined,
  CopyOutlined,
  CreditCardOutlined,
  CrownOutlined,
  DashboardOutlined,
  DatabaseOutlined,
  DeleteOutlined,
  DesktopOutlined,
  DollarOutlined,
  DownOutlined,
  DownloadOutlined,
  DragOutlined,
  EditOutlined,
  EnvironmentOutlined,
  ExclamationCircleOutlined,
  ExportOutlined,
  EyeOutlined,
  FallOutlined,
  FieldTimeOutlined,
  FileExcelOutlined,
  FileOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileSearchOutlined,
  FileTextOutlined,
  FileWordOutlined,
  FileZipOutlined,
  FilterOutlined,
  FireOutlined,
  FolderOpenOutlined,
  FolderOutlined,
  FullscreenOutlined,
  FundOutlined,
  GiftOutlined,
  GlobalOutlined,
  HistoryOutlined,
  HomeOutlined,
  IdcardOutlined,
  ImportOutlined,
  InboxOutlined,
  InfoCircleOutlined,
  InteractionOutlined,
  KeyOutlined,
  LineChartOutlined,
  LinkOutlined,
  LoadingOutlined,
  LockOutlined,
  LoginOutlined,
  LogoutOutlined,
  MailOutlined,
  ManOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  MenuUnfoldOutlined,
  MinusCircleOutlined,
  MobileOutlined,
  MoneyCollectOutlined,
  MonitorOutlined,
  MoonOutlined,
  MoreOutlined,
  NodeIndexOutlined,
  OrderedListOutlined,
  PaperClipOutlined,
  PartitionOutlined,
  PauseCircleOutlined,
  PhoneOutlined,
  PicLeftOutlined,
  PictureOutlined,
  PieChartOutlined,
  PlayCircleOutlined,
  PlusOutlined,
  PoweroffOutlined,
  PrinterOutlined,
  ProfileOutlined,
  ProjectOutlined,
  QrcodeOutlined,
  QuestionCircleOutlined,
  QuestionOutlined,
  ReloadOutlined,
  RiseOutlined,
  RocketOutlined,
  RollbackOutlined,
  SafetyCertificateOutlined,
  SafetyOutlined,
  SaveOutlined,
  SearchOutlined,
  SendOutlined,
  SettingOutlined,
  ShareAltOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  ShoppingOutlined,
  SketchOutlined,
  SolutionOutlined,
  StarFilled,
  StarOutlined,
  StockOutlined,
  SunOutlined,
  SwapOutlined,
  SyncOutlined,
  TableOutlined,
  TagOutlined,
  TagsOutlined,
  TeamOutlined,
  TransactionOutlined,
  TranslationOutlined,
  TrophyOutlined,
  TruckOutlined,
  UnlockOutlined,
  UnorderedListOutlined,
  UpOutlined,
  UploadOutlined,
  UserOutlined,
  UserSwitchOutlined,
  VideoCameraOutlined,
  WalletOutlined,
  WarningOutlined,
  WomanOutlined,
};

/**
 * 获取图标组件
 * @param iconName 图标名称
 * @returns 图标组件或null
 */
export function getIcon(iconName?: string): React.ComponentType | null {
  if (!iconName) return null;

  const IconComponent = iconRegistry[iconName];

  if (!IconComponent) {
    // 开发环境下警告
    if (process.env.NODE_ENV !== 'production') {
      console.warn(
        `Icon "${iconName}" is not registered. ` +
        `Please add it to iconRegistry.ts. ` +
        `Available icons: ${Object.keys(iconRegistry).length} registered.`
      );
    }
    return null;
  }

  return IconComponent;
}

/**
 * 获取所有已注册的图标名称
 * @returns 图标名称数组
 */
export function getRegisteredIconNames(): string[] {
  return Object.keys(iconRegistry);
}

/**
 * 检查图标是否已注册
 * @param iconName 图标名称
 * @returns 是否已注册
 */
export function isIconRegistered(iconName: string): boolean {
  return iconName in iconRegistry;
}

/**
 * 获取已注册图标的数量
 * @returns 图标数量
 */
export function getIconCount(): number {
  return Object.keys(iconRegistry).length;
}

// 导出所有函数作为默认对象
export default {
  getIcon,
  getRegisteredIconNames,
  isIconRegistered,
  getIconCount,
  iconRegistry,
};
